export class ApplicationError extends Error {
  constructor(message, httpError) {
    super(message);
    this.httpError = httpError;
  }
}
